// extracted by mini-css-extract-plugin
export default {"v-small":"(max-width: 480px)","v-fog":"var(--fog)","v-white":"var(--white)","container":"navbar__container__aPbkq","navList":"navbar__navList__Ke9_v"};